// import React, { useState, useEffect } from "react";
// import axios from "axios"; // Import axios

// const AppointmentDashboard = () => {
//   const [appointments, setAppointments] = useState([]);

//   useEffect(() => {
//     // Fetch appointments data from the API using axios
//     axios
//       .get("https://webex.eregistrationukgov.in/api/DemoDashboard")
//       .then((response) => {
//         console.log("API Response:", response.data); // Log the response for debugging
//         setAppointments(response.data); // Set the appointments data
//       })
//       .catch((error) => {
//         console.error("Error fetching appointments:", error); // Handle error
//       });
//   }, []);

//   const openMeetingLink = (url) => {
//     // Open the meeting link in a new tab
//     window.open(url, "_blank");
//   };

//   return (
//     <div>
//       <h2>Scheduled Virtual Appointments</h2>
//       <table border="1" style={{ width: "100%", borderCollapse: "collapse" }}>
//         <thead>
//           <tr>
//             <th>Appointment ID</th>
//             <th>Applicant Name</th>
//             <th>Meeting Link</th>
//             <th>Action</th> {/* Added an extra column for the button */}
//           </tr>
//         </thead>
//         <tbody>
//           {appointments.length === 0 ? (
//             <tr>
//               <td colSpan="4" style={{ textAlign: "center" }}>
//                 No appointments available.
//               </td>
//             </tr>
//           ) : (
//             appointments.map((appointment) => {
//               return (
//                 <tr key={appointment.appointment_Id}>
//                   <td>{appointment.appointment_Id}</td>
//                   <td>{appointment.applicant_Name}</td>
//                   <td>
//                     {appointment.meeting_Link ? (
//                       <a
//                         href={appointment.meeting_Link}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         style={{ color: "blue", textDecoration: "underline" }}
//                       >
//                         {appointment.meeting_Link}
//                       </a>
//                     ) : (
//                       "No Link Available"
//                     )}
//                   </td>
//                   <td>
//                     {appointment.meeting_Link ? (
//                       <button
//                         onClick={() =>
//                           openMeetingLink(appointment.meeting_Link)
//                         }
//                         style={{ padding: "5px 10px", cursor: "pointer" }}
//                       >
//                         Join Meeting
//                       </button>
//                     ) : (
//                       "No Link Available"
//                     )}
//                   </td>
//                 </tr>
//               );
//             })
//           )}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default AppointmentDashboard;

// import React, { useState, useEffect } from "react";
// import axios from "axios"; // Import axios

// const AppointmentDashboard = () => {
//   const [appointments, setAppointments] = useState([]);
//   const [meetingUrl, setMeetingUrl] = useState("");

//   useEffect(() => {
//     // Fetch appointments data from the API using axios
//     axios
//       .get("https://localhost:7186/api/DemoDashboard")
//       .then((response) => {
//         console.log("API Response:", response.data); // Log the response for debugging
//         setAppointments(response.data); // Set the appointments data
//       })
//       .catch((error) => {
//         console.error("Error fetching appointments:", error); // Handle error
//       });
//   }, []);

//   const openMeetingLink = (url) => {
//     // Set the meeting URL to display in the iframe
//     setMeetingUrl(url);
//   };

//   return (
//     <div>
//       <h2>Scheduled Virtual Appointments</h2>
//       <table border="1" style={{ width: "100%", borderCollapse: "collapse" }}>
//         <thead>
//           <tr>
//             <th>Appointment ID</th>
//             <th>Applicant Name</th>
//             <th>Meeting Link</th>
//             <th>Action</th> {/* Added an extra column for the button */}
//           </tr>
//         </thead>
//         <tbody>
//           {appointments.length === 0 ? (
//             <tr>
//               <td colSpan="4" style={{ textAlign: "center" }}>
//                 No appointments available.
//               </td>
//             </tr>
//           ) : (
//             appointments.map((appointment) => {
//               return (
//                 <tr key={appointment.appointment_Id}>
//                   <td>{appointment.appointment_Id}</td>
//                   <td>{appointment.applicant_Name}</td>
//                   <td>
//                     {appointment.meeting_Link ? (
//                       <a
//                         href="#"
//                         onClick={() =>
//                           openMeetingLink(appointment.meeting_Link)
//                         }
//                         style={{ color: "blue", textDecoration: "underline" }}
//                       >
//                         Open Meeting
//                       </a>
//                     ) : (
//                       "No Link Available"
//                     )}
//                   </td>
//                   <td>
//                     {appointment.meeting_Link ? (
//                       <button
//                         onClick={() =>
//                           openMeetingLink(appointment.meeting_Link)
//                         }
//                         style={{ padding: "5px 10px", cursor: "pointer" }}
//                       >
//                         Join Meeting
//                       </button>
//                     ) : (
//                       "No Link Available"
//                     )}
//                   </td>
//                 </tr>
//               );
//             })
//           )}
//         </tbody>
//       </table>
//       {meetingUrl && (
//         <div style={{ marginTop: "20px" }}>
//           <h3>Meeting</h3>
//           <iframe
//             src={meetingUrl}
//             width="100%"
//             height="600px"
//             style={{ border: "none" }}
//             title="Webex Meeting"
//             onLoad={() => console.log("Iframe loaded successfully.")}
//             onError={(e) => console.error("Error loading iframe", e)}
//           ></iframe>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AppointmentDashboard;

// import React, { useState, useEffect } from "react";
// import { WebexMeetingsWidget } from "@webex/widgets";
// import "@webex/widgets/dist/css/webex-widgets.css";

// const AppointmentDashboard = () => {
//   const [appointments, setAppointments] = useState([]);
//   const [accessToken, setAccessToken] = useState(""); // State to hold access token
//   const [currentMeeting, setCurrentMeeting] = useState(null); // State to hold the current meeting ID

//   useEffect(() => {
//     console.log("Fetching appointments data...");
//     // Fetch appointments data
//     fetch("https://localhost:7186/api/DemoDashboard")
//       .then((response) => {
//         console.log("Appointment fetch response:", response);
//         if (!response.ok) {
//           throw new Error("Failed to fetch appointments");
//         }
//         return response.json();
//       })
//       .then((data) => {
//         console.log("Fetched appointments data:", data);
//         setAppointments(data);
//       })
//       .catch((error) => {
//         console.error("Error fetching appointments:", error);
//       });

//     console.log("Fetching Webex access token...");
//     // Fetch Webex access token from backend
//     fetch(
//       "https://localhost:7186/api/FrontendToken/GetValidFrontendAccessToken"
//     )
//       .then((response) => {
//         console.log("Access token fetch response:", response);
//         if (!response.ok) {
//           throw new Error("Failed to fetch access token");
//         }
//         return response.text();
//       })
//       .then((data) => {
//         console.log("Fetched access token:", data.token);
//         setAccessToken(data); // Ensure the correct token is set
//       })
//       .catch((error) => {
//         console.error("Error fetching access token:", error);
//       });
//   }, []);

//   // Function to extract meeting ID from the Webex meeting link using regex
//   const extractMeetingId = (meetingLink) => {
//     console.log("Extracting meeting ID from link:", meetingLink);
//     const regex = /MTID=([a-zA-Z0-9_-]+)/; // Match MTID pattern
//     const match = meetingLink.match(regex);
//     const meetingId = match ? match[1] : null; // Return the meeting ID or null if not found
//     console.log("Extracted meeting ID:", meetingId);
//     return meetingId;
//   };

//   // Function to handle joining the meeting
//   const handleJoinMeeting = (meetingLink) => {
//     console.log("Joining meeting with link:", meetingLink);
//     const meetingId = extractMeetingId(meetingLink); // Extract the meeting ID from the link
//     console.log("Meeting ID extracted:", meetingId); // Log the extracted ID for debugging
//     if (meetingId) {
//       setCurrentMeeting(meetingLink); // Set the current meeting link to be opened in the widget
//     } else {
//       console.error("No valid meeting ID found");
//     }
//   };

//   return (
//     <div>
//       <h2>Scheduled Virtual Appointments</h2>
//       <table border="1" style={{ width: "100%", borderCollapse: "collapse" }}>
//         <thead>
//           <tr>
//             <th>Appointment ID</th>
//             <th>Applicant Name</th>
//             <th>Meeting Link</th>
//             <th>Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {appointments.length === 0 ? (
//             <tr>
//               <td colSpan="4" style={{ textAlign: "center" }}>
//                 No appointments available.
//               </td>
//             </tr>
//           ) : (
//             appointments.map((appointment) => (
//               <tr key={appointment.appointment_Id}>
//                 <td>{appointment.appointment_Id}</td>
//                 <td>{appointment.applicant_Name}</td>
//                 <td>
//                   {appointment.meeting_Link ? (
//                     <button
//                       onClick={() =>
//                         handleJoinMeeting(appointment.meeting_Link)
//                       }
//                       style={{ padding: "5px 10px", cursor: "pointer" }}
//                     >
//                       Join Meeting
//                     </button>
//                   ) : (
//                     "No Meeting Available"
//                   )}
//                 </td>
//               </tr>
//             ))
//           )}
//         </tbody>
//       </table>

//       {/* Show the meeting in the Webex Meetings widget when the currentMeeting is set */}
//       {currentMeeting && accessToken && (
//         <div style={{ marginTop: "20px", border: "1px solid #ccc" }}>
//           <WebexMeetingsWidget
//             style={{ width: "1000px", height: "500px" }} // Substitute with any arbitrary size or use `className`
//             accessToken={accessToken}
//             meetingDestination={currentMeeting} // Use the meeting link directly
//             onError={(error) => {
//               console.error("Webex widget error:", error); // Log Webex widget error
//               alert("Error joining meeting: " + JSON.stringify(error)); // Show alert for debugging
//             }}
//             onLoad={() => {
//               console.log("Webex widget loaded successfully"); // Log when widget is loaded
//             }}
//           />
//         </div>
//       )}
//     </div>
//   );
// };

// export default AppointmentDashboard;

import React, { useState, useEffect } from "react";
import { WebexMeetingsWidget } from "@webex/widgets";
import "@webex/widgets/dist/css/webex-widgets.css";
import Modal from "react-modal";
import "tailwindcss/tailwind.css"; // Ensure Tailwind is imported
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "./pages/Footer";

const AppointmentDashboard = () => {
  const [appointments, setAppointments] = useState([]);
  const [accessToken, setAccessToken] = useState(""); // State to hold access token
  const [currentMeeting, setCurrentMeeting] = useState(null); // State to hold the current meeting ID
  const [modalIsOpen, setModalIsOpen] = useState(false); // State to control modal visibility

  useEffect(() => {
    console.log("Fetching appointments data...");
    // Fetch appointments data
    fetch("https://webex.eregistrationukgov.in/api/DemoDashboard")
      .then((response) => {
        console.log("Appointment fetch response:", response);
        if (!response.ok) {
          throw new Error("Failed to fetch appointments");
        }
        return response.json();
      })
      .then((data) => {
        console.log("Fetched appointments data:", data);
        setAppointments(data);
      })
      .catch((error) => {
        console.error("Error fetching appointments:", error);
      });

    console.log("Fetching Webex access token...");
    // Fetch Webex access token from backend
    fetch(
      "https://webex.eregistrationukgov.in/api/FrontendToken/GetValidFrontendAccessToken"
    )
      .then((response) => {
        console.log("Access token fetch response:", response);
        if (!response.ok) {
          throw new Error("Failed to fetch access token");
        }
        return response.text();
      })
      .then((data) => {
        console.log("Fetched access token:", data);
        setAccessToken(data); // Ensure the correct token is set
      })
      .catch((error) => {
        console.error("Error fetching access token:", error);
      });
  }, []);

  // Function to extract meeting ID from the Webex meeting link using regex
  const extractMeetingId = (meetingLink) => {
    console.log("Extracting meeting ID from link:", meetingLink);
    const regex = /MTID=([a-zA-Z0-9_-]+)/; // Match MTID pattern
    const match = meetingLink.match(regex);
    const meetingId = match ? match[1] : null; // Return the meeting ID or null if not found
    console.log("Extracted meeting ID:", meetingId);
    return meetingId;
  };

  // Function to handle joining the meeting
  const handleJoinMeeting = (meetingLink) => {
    console.log("Joining meeting with link:", meetingLink);
    const meetingId = extractMeetingId(meetingLink); // Extract the meeting ID from the link
    console.log("Meeting ID extracted:", meetingId); // Log the extracted ID for debugging
    if (meetingId) {
      setCurrentMeeting(meetingLink); // Set the current meeting link to be opened in the widget
      setModalIsOpen(true); // Open the modal
    } else {
      console.error("No valid meeting ID found");
    }
  };

  const closeModal = () => {
    setModalIsOpen(false); // Close the modal
    setCurrentMeeting(null); // Clear the current meeting
  };

  return (
    <div>
      <h2>Scheduled Virtual Appointments</h2>
      <table border="1" className="w-full border-collapse">
        <thead>
          <tr>
            <th>Appointment ID</th>
            <th>Applicant Name</th>
            <th>Meeting Link</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {appointments.length === 0 ? (
            <tr>
              <td colSpan="4" className="text-center">
                No appointments available.
              </td>
            </tr>
          ) : (
            appointments.map((appointment) => (
              <tr key={appointment.appointment_Id}>
                <td>{appointment.appointment_Id}</td>
                <td>{appointment.applicant_Name}</td>
                <td>
                  {appointment.meeting_Link ? (
                    <button
                      onClick={() =>
                        handleJoinMeeting(appointment.meeting_Link)
                      }
                      className="px-4 py-2 cursor-pointer bg-blue-500 text-white rounded"
                    >
                      Join Meeting
                    </button>
                  ) : (
                    "No Meeting Available"
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* Modal for Webex Meetings widget */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75"
        contentLabel="Join Webex Meeting"
        style={{ overlay: { zIndex: 1000 } }}
      >
        <div className="bg-white p-4 rounded shadow-lg w-full max-w-screen-lg h-screen">
          <button
            onClick={closeModal}
            className="float-right bg-red-500 text-white px-2 py-1 rounded"
          >
            Close
          </button>
          {currentMeeting && accessToken && (
            <WebexMeetingsWidget
              style={{ width: "100%", height: "calc(100vh - 60px)" }} // Adjusted to fill the screen minus some padding
              accessToken={accessToken}
              meetingDestination={currentMeeting} // Use the meeting link directly
              onError={(error) => {
                console.error("Webex widget error:", error); // Log Webex widget error
                toast.error("Error joining meeting: " + JSON.stringify(error)); // Show alert for debugging
              }}
              onLoad={() => {
                console.log("Webex widget loaded successfully"); // Log when widget is loaded
              }}
            />
          )}
        </div>
      </Modal>
      <Footer />
    </div>
  );
};

export default AppointmentDashboard;
